import { Injectable } from '@angular/core'
import { Config } from '@spartacus/core'
import { MbCheckoutStep } from '../models'

@Injectable({
  providedIn: 'root',
  useExisting: Config,
})
export abstract class CheckoutConfig {
  checkout?: {
    /**
     * Set registration steps as ordered array of pages.
     */
    steps?: MbCheckoutStep[];
  }
}
